import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function DonationFailure() {
  const { t } = useTranslation();
  return (
    <div style={{ textAlign: 'center', padding: '80px 20px', minHeight: '60vh' }}>
      <div style={{ fontSize: '5rem', marginBottom: 20 }}>😔</div>
      <h1 style={{ fontSize: '2rem', fontWeight: 700, color: '#c62828', marginBottom: 12 }}>{t('donationFailure.title')}</h1>
      <p style={{ color: '#555', marginBottom: 24 }}>{t('donationFailure.message')}</p>
      <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link to="/donations" className="btn btn-primary">{t('donationFailure.tryAgain')}</Link>
        <Link to="/" className="btn btn-outline">{t('common.backToHome')}</Link>
      </div>
    </div>
  );
}
